import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-footer',
    styleUrls: ['./footer.component.scss'],
    templateUrl: './footer.component.html',
    standalone: false
})
export class FooterComponent implements OnInit {

  constructor() { }

  public ngOnInit() {
  }

}
